import { PagedRequest } from '../common/paged-response.model';

/** The generated-reports list's delivery filter values (the API also accepts them case-insensitively). */
export type DeliveryStatusFilter = 'sent' | 'failed' | 'notSent' | 'optedOut';

/** Filter and paging parameters for `POST api/reports/ViewGeneratedReports`. */
export class ReportSentDataRequest implements PagedRequest {
    startDate: Date;
    endDate: Date;
    tutorId: number;
    clientId: number;
    clientName: string;
    referrerEmail: string;
    coordinatorId: number;
    studentId: number;
    placementId: number;
    studentName: string;
    reportType: string;
    clientIds: number[];
    /** Brands to restrict to; empty or absent means every brand the user may see. */
    companyIds?: number[];
    /** Recipient search: the referrer email contains this text. */
    referrerContains?: string | null;
    /**
     * Delivery filter. Absent = the default list, which hides failed and opted-out lines; sent only
     * while the filters.reports-sent switch is on and a status is picked.
     */
    deliveryStatus?: DeliveryStatusFilter;

    /** 1-based page to fetch. */
    pageNumber: number;
    /** Rows per page. The API clamps this to 200. */
    pageSize: number;
    /** Column to sort by, or null for the query's default order (generated date, then client name). */
    sortField?: string;
    /** 'asc' or 'desc'. */
    sortDirection?: string;

    constructor() {}
}